import Image, { type ImageProps } from "next/image";

/** Absolute URL, protocol-relative, root-relative or inline — anything `next/image` can actually load. */
export function isLoadableSrc(src: unknown): src is string {
  return typeof src === "string" && /^(https?:\/\/|\/|data:|blob:)/.test(src);
}

/**
 * `next/image` for backend media. Covers come from imgproxy, already resized
 * to the preset the API chose, so they're served `unoptimized` (no second
 * resize pass, and no `remotePatterns` entry needed per imgproxy host). A raw
 * storage key that slipped through unresolved (e.g. `imports/covers/…`)
 * renders nothing instead of throwing `Failed to parse src` and taking the
 * whole page down — the caller's own placeholder background shows instead.
 */
export function MediaImage({ src, alt, unoptimized, ...props }: ImageProps) {
  if (typeof src === "string" && !isLoadableSrc(src)) return null;
  return (
    <Image src={src} alt={alt} unoptimized={unoptimized ?? typeof src === "string"} {...props} />
  );
}
